import { useState, useMemo } from "react";
import type { ContractListResponseDto } from "@semo/api-contracts";

export type ExternalContractFilter = "all" | "COMPLETED" | "CANCELED";

export function useExternalContractFilters(
  contracts: ContractListResponseDto[],
) {
  const [activeFilter, setActiveFilter] =
    useState<ExternalContractFilter>("all");

  const counts = useMemo(() => {
    return {
      all: contracts.length,
      COMPLETED: contracts.filter((c) => c.status === "COMPLETED").length,
      CANCELED: contracts.filter((c) => c.status === "CANCELED").length,
    };
  }, [contracts]);

  const filteredContracts = useMemo(() => {
    if (activeFilter === "all") return contracts;
    return contracts.filter((c) => c.status === activeFilter);
  }, [contracts, activeFilter]);

  return {
    activeFilter,
    setActiveFilter,
    filteredContracts,
    counts,
  };
}
